import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'item', 'icon'];
var baseStyleContainer = {};
var baseStyleItem = {};
var baseStyleIcon = {
  marginEnd: '0.5rem',
  display: 'inline',
  verticalAlign: 'text-bottom'
};
var baseStyle = {
  container: baseStyleContainer,
  item: baseStyleItem,
  icon: baseStyleIcon
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});